export default {
  functionKey: "FINIT PAR",
  title: "FINIT PAR",
  group: "Organisation",
  origin: [],
  arguments: [],
  target: [],
  maxArguments: 1,
  requiredArguments: [{ argumentKey: "Suffix", name: "Suffixe" }],
  expectedArguments: [
    { name: "Suffixe", argumentKey: "Suffix", single: true, initialValue: "" }
  ],
  description: "Evalue si le texte d'origine termine par le texte de l'argument",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = ${destination} ? ${origin}.endsWith(${args[0]}) : false;`;
    return { displayCode: code, safeCode: code };
  }
}
